export interface SidebarModuleConfig {
  key: string;
  label: string;
  icon: string;
  description: string;
  locked?: boolean;
}

export const SIDEBAR_MODULES: readonly SidebarModuleConfig[] = [
  {
    key: 'vue-globale',
    label: 'Vue globale',
    icon: 'pi-th-large',
    description: 'Tableau de bord, analytique et accès de pilotage quotidien.',
    locked: true,
  },
  {
    key: 'ged-documents',
    label: 'GED & documents',
    icon: 'pi-folder-open',
    description: 'Documents médicaux, documentation, bibliothèque et formulaires.',
  },
  {
    key: 'patients-soins',
    label: 'Patients & soins',
    icon: 'pi-users',
    description: 'Patients, rendez-vous, consultations, ordonnances et carnet de santé.',
  },
  {
    key: 'examens-analyses',
    label: 'Examens & analyses',
    icon: 'pi-chart-scatter',
    description: 'Laboratoire, catalogue de tests, résultats et imagerie médicale.',
  },
  {
    key: 'hospitalisation',
    label: 'Hospitalisation, chirurgie & soins',
    icon: 'pi-building',
    description: 'Hospitalisations, lits, blocs opératoires, chirurgies, soins et banque de sang.',
  },
  {
    key: 'maternite',
    label: 'Maternité',
    icon: 'pi-heart-fill',
    description: 'Grossesses, visites prénatales, accouchements et nouveau-nés.',
  },
  {
    key: 'pharmacie-stock',
    label: 'Pharmacie & stock',
    icon: 'pi-shopping-cart',
    description: 'Caisse, ventes, catalogue médicaments, inventaire, commandes et fournisseurs.',
  },
  {
    key: 'urgences-logistique',
    label: 'Urgences & logistique',
    icon: 'pi-bolt',
    description: 'Régulation des urgences, ambulances, flotte, maintenance et analyse.',
  },
  {
    key: 'finance-facturation',
    label: 'Finance & facturation',
    icon: 'pi-credit-card',
    description: 'Tarification, factures, devis, assurances, transactions et recouvrement.',
  },
  {
    key: 'ressources-humaines',
    label: 'Ressources humaines',
    icon: 'pi-id-card',
    description: 'Personnel, départements, plannings, présences, congés et paie.',
  },
  {
    key: 'administration',
    label: 'Administration',
    icon: 'pi-cog',
    description: 'Organisation, modules, rôles, paramètres, audit et outils de gouvernance.',
    locked: true,
  },
] as const;

export type SidebarModuleKey = typeof SIDEBAR_MODULES[number]['key'];
